module.exports = __webpack_public_path__ + "media/images/drivers-topbar-a0b632012a9446105ae36c0ac5ba7def.svg";